import type { IntlShape } from 'react-intl';

import { EntityType } from '~/enums/EntityType';

export const getEntityDisplayType = ({
  entityType,
  intl,
}: {
  entityType?: EntityType;
  intl: IntlShape;
}) => {
  switch (entityType) {
    case EntityType.DocumentAttachedData:
      return intl.formatMessage({
        id: 'Xray.modelDetails.tableEntityType',
        defaultMessage: 'Table',
        description: 'Table entity type',
      });
    case EntityType.Field:
      return intl.formatMessage({
        id: 'Xray.modelDetails.fieldEntityType',
        defaultMessage: 'Field',
        description: 'Field entity type',
      });
    default:
      return '';
  }
};

export const getEntityDisplayTypeLower = ({
  entityType,
  intl,
}: {
  entityType?: EntityType;
  intl: IntlShape;
}) => {
  switch (entityType) {
    case EntityType.DocumentAttachedData:
      return intl.formatMessage({
        id: 'Xray.modelDetails.tableEntityTypeLowercase',
        defaultMessage: 'table',
        description: 'Table entity type',
      });
    case EntityType.Field:
      return intl.formatMessage({
        id: 'Xray.modelDetails.fieldEntityTypeLowercase',
        defaultMessage: 'field',
        description: 'Field entity type',
      });
    default:
      return '';
  }
};
